import firebase_ from "../../../firebase/firebase";

export const fetchUsers = async () => {
  const userList = [];
  const db = firebase_.firestore();
  await db
    .collection("Users")
    .get()
    .then((res) => {
      res.forEach((item) => {
        userList.push({ value: item.data(), label: item.data() });
      });
      return userList;
    })
    .catch((err) => {
      console.log("error in fetching Users", err);
    });
  return userList;
};
